import { useState } from 'react';
import { Copy, Check, RefreshCw } from 'lucide-react';
import useAutomationsStore from '../../../../../../store/useAutomationsStore';
import useCompany from '../../../../../../hooks/useCompany';
import { getInitialNodeData } from '../../../constants/nodeDefaults';

export default function WebhookConfig({ data, onChange }) {
  const { currentWorkflow } = useAutomationsStore();
  const { activeCompany } = useCompany();
  const [copied, setCopied] = useState(null);

  const workflowId = currentWorkflow?.id || '';
  const baseUrl = `${import.meta.env.VITE_WALLETTWO_URL}/workflow`;
  const companyId = activeCompany?.id || '';
  const webhookUrl = `${baseUrl}/v1/${companyId}/${workflowId}/webhook?secret_key=${data.secretKey || ''}`;

  const handleCopy = async (text, key) => {
    await navigator.clipboard.writeText(text);
    setCopied(key);
    setTimeout(() => setCopied(null), 2000);
  };

  const handleRegenerate = () => {
    onChange('secretKey', getInitialNodeData('trigger_webhook').secretKey);
  };

  return (
    <div className="space-y-4">
      {/* Webhook URL */}
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1.5">Webhook URL</label>
        <div className="flex items-start gap-1.5">
          <div className="flex-1 min-w-0 px-3 py-2 text-[11px] font-mono bg-gray-50 border border-gray-200 rounded-lg break-all text-gray-700 select-all">
            {webhookUrl}
          </div>
          <button
            type="button"
            onClick={() => handleCopy(webhookUrl, 'url')}
            className="shrink-0 p-2 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 transition"
            title="Copy URL"
          >
            {copied === 'url' ? (
              <Check className="w-3.5 h-3.5 text-emerald-500" />
            ) : (
              <Copy className="w-3.5 h-3.5 text-gray-400" />
            )}
          </button>
        </div>
        <p className="text-[10px] text-gray-400 mt-1.5">
          Send a POST request to this URL to trigger the workflow.
        </p>
      </div>

      {/* Regenerate */}
      <button
        type="button"
        onClick={handleRegenerate}
        className="flex items-center gap-2 w-full px-3 py-2 text-sm font-medium text-amber-700 bg-amber-50 hover:bg-amber-100 border border-amber-200 rounded-lg transition"
      >
        <RefreshCw className="w-3.5 h-3.5" />
        Regenerate Secret Key
      </button>
      <p className="text-[10px] text-gray-400 -mt-2">
        This will invalidate the current webhook URL. Any services using the old URL will stop working.
      </p>
    </div>
  );
}
